<template>
  <base-widget
    title="Notes"
    :style="heightStyles"
    scrollable
    :loading="loading"
  >
    <template slot="right">
      <base-link-with-icon
        icon="plus"
        class="mr-2"
        @click="openEditor"
      >
        Add Note
      </base-link-with-icon>
    </template>
    <template slot="after-heading">
      <notification-editor
        v-if="editor"
        :emojis="true"
        :attachments="false"
        @cancel="editor = false"
        @post="$emit('add-note', $event); editor = false"
      />
    </template>

    <template v-if="!loading && items.length === 0">
      <empty title="No notes yet">
        <a
          href="#"
          class="link-orange font-weight-bold"
          @click.prevent="openEditor"
        >Add a note</a> to start giving yourself little reminders!
      </empty>
    </template>

    <notification-item
      v-for="(note, index) in items"
      :key="`information_note_${index}`"
      :title="note.author_user.first_name + ' ' + note.author_user.last_name"
      :date="note.date"
      :message="note.text"
      :can-delete="canDelete(note)"
      @delete="$emit('delete-item', note.id)"
    />
  </base-widget>
</template>

<script>
import NotificationEditor from '@/components/Widgets/Notifications/NotificationEditor';
import NotificationItem from '@/components/Widgets/Notifications/NotificationItem';
import minHeightMixin from '../mixins/minheight';

export default {
  name: 'Notes',
  components: {
    NotificationItem,
    NotificationEditor,
  },
  mixins: [minHeightMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editor: false,
    };
  },
  methods: {
    openEditor() {
      this.editor = true;
    },
    canDelete(item) {
      const { profile } = this.$store.state.account.user;
      const { role } = profile;
      const isSender = profile.pk === item.author;
      return role.includes('manager') || isSender;
    },
  },
};
</script>
